import { FETCH_ROOT_PAGE } from "../actions/rootPageActions";

const initState = {};

const rootPageReducer = (state = initState, action) => {
    if (action.type === FETCH_ROOT_PAGE) {
        return {
            ...state,
            ...action.payload,
        };
    }

    return state;
};

export default rootPageReducer;
